import { isNil, values } from 'lodash/fp';

import { INSURANCE_TYPES } from '../../../src/client/pages/insurance/constants';
import getContent from '../../../src/client/pages/insurance/privacy/content';
import getInsuranceTypeFromLocation from '../../../src/client/pages/insurance/utils/get-insurance-type-from-location';
import getStaticPathsForInsuranceTypes from '../utils/get-static-paths-for-insurance-types';
import InsurancePrivacy, { InsurancePrivacyProps } from '../../../src/client/pages/insurance/privacy';

const PrivacyPolicy = ({ content }: InsurancePrivacyProps) => <InsurancePrivacy content={content} />;

export const getStaticPaths = () => getStaticPathsForInsuranceTypes([...values(INSURANCE_TYPES), 'car-and-home']);

export const getStaticProps = async ({ params: { insuranceType } }: { params: { insuranceType: string } }) => {
  const shortInsuranceType = getInsuranceTypeFromLocation(insuranceType);
  const content = getContent(shortInsuranceType);

  return {
    props: {
      content: isNil(content) ? null : content,
    },
  };
};

export default PrivacyPolicy;
